import React from 'react'
import { connect } from 'react-redux'
import UsersIndex from './UsersIndex'

import { set_path } from '../actions/'

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    setPath: path => dispatch( set_path(path) )
  }
}

class ConnectedTestTakers extends React.Component {
  componentWillMount() {
    this.props.setPath('testtakers') // change depending on component
  }

  render() {
    return <UsersIndex header="Test Takers" userbase="user" />
  }
}

const TestTakers = connect(mapStateToProps, mapDispatchToProps)(ConnectedTestTakers)

export default TestTakers



// WEBPACK FOOTER //
// ./src/js/components/TestTakers.js